<template>
  <b-dropdown-item @click="$emit('select', field)">
    {{ field.label }}
    <span class="d-inline-flex text-secondary text-small" v-if="projectTitle">
      (<span class="project-title text-truncate" :title="projectTitle">{{ projectTitle }}</span
      >)
    </span>
  </b-dropdown-item>
</template>

<script>
import { BDropdownItem } from 'bootstrap-vue'
import { mapActions } from 'vuex'

/**
 * This is the item for CustomField in AddFilter Dropdown
 */
export default {
  name: 'CustomFieldFilterOption',
  props: ['field', 'orgId'],
  components: { BDropdownItem },
  computed: {
    projectTitle() {
      return (
        this.field.projectId &&
        this.$store.getters['project/projectById'](this.field.projectId)?.title
      )
    }
  },
  methods: {
    ...mapActions('project', ['getProject'])
  },
  mounted() {
    if (this.field.projectId && !this.projectTitle) {
      this.getProject({ orgId: this.orgId, projectId: this.field.projectId })
    }
  }
}
</script>

<style scoped lang="scss">
.project-title {
  max-width: 100px;
  display: inline-block;
}
</style>
